/* Cookies Directive - The rewrite. Now a jQuery plugin
 * Version: 2.0.1
 * Author: Ollie Phillips
 * 24 October 2013
 */

;

(function($) {
    var empresa = "Grupo AVA"
    $.cookiesDirective = function(options) {

        // Default Cookies Directive Settings
        var settings = $.extend({
            //Options
            explicitConsent: true,
            position: 'top',
            duration: 10,
            limit: 0,
            message: null,
            cookieScripts: null,
            privacyPolicyUri: 'privacy.html',
            scriptWrapper: function() {},
            // Styling
            fontFamily: 'helvetica',
            fontColor: '#FFFFFF',
            fontSize: '13px',
            backgroundColor: '#000000',
            backgroundOpacity: '80',
            linkColor: '#85B100'
        }, options);

        // Perform consent checks
        if (!getCookie('cookiesDirective')) {
            if (settings.limit > 0) {
                // Display limit in force, record the view
                if (!getCookie('cookiesDisclosureCount')) {
                    setCookie('cookiesDisclosureCount', 1, 1);
                } else {
                    var disclosureCount = getCookie('cookiesDisclosureCount');
                    disclosureCount++;
                    setCookie('cookiesDisclosureCount', disclosureCount, 1);
                }

                // Have we reached the display limit, if not make disclosure
                if (settings.limit >= getCookie('cookiesDisclosureCount')) {
                    disclosure(settings);
                }
            } else {
                // No display limit
                disclosure(settings);
            }

            // If we don't require explicit consent, load up our script wrapping function
            if (!settings.explicitConsent) {
                settings.scriptWrapper.call();
            }
        } else {
            // Cookies accepted, load script wrapping function
            settings.scriptWrapper.call();
        }
    };

    // Used to load external javascript files into the DOM
    $.cookiesDirective.loadScript = function(options) {
        var settings = $.extend({
            uri: '',
            appendTo: 'body'
        }, options);

        var elementId = String(settings.appendTo);
        var sA = document.createElement("script");
        sA.src = settings.uri;
        sA.type = "text/javascript";
        sA.onload = sA.onreadystatechange = function() {
            if ((!sA.readyState || sA.readyState == "loaded" || sA.readyState == "complete")) {
                return;
            }
        }
        switch (settings.appendTo) {
            case 'head':
                $('head').append(sA);
                break;
            case 'body':
                $('body').append(sA);
                break;
            default:
                $('#' + elementId).append(sA);
        }
    }

    // Helper scripts
    // Get cookie
    var getCookie = function(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    // Set cookie
    var setCookie = function(name, value, days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
        } else var expires = "";
        document.cookie = name + "=" + value + expires + "; path=/";
    }

    // Detect IE < 9
    var checkIE = function() {
        var version;
        if (navigator.appName == 'Microsoft Internet Explorer') {
            var ua = navigator.userAgent;
            var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
            if (re.exec(ua) != null) {
                version = parseFloat(RegExp.$1);
            }
            if (version <= 8.0) {
                return true;
            } else {
                if (version == 9.0) {
                    if (document.compatMode == "BackCompat") {
                        // IE9 in quirks mode won't run the script properly, set to emulate IE8	
                        var mA = document.createElement("meta");
                        mA.content = "IE=EmulateIE8";
                        document.getElementsByTagName('head')[0].appendChild(mA);
                        return true;
                    } else {
                        return false;
                    }
                }
                return false;
            }
        } else {
            return false;
        }
    }

    // Disclosure routines
    var disclosure = function(options) {
        var settings = options;
        settings.css = 'fixed';

        // IE 9 and lower has issues with position:fixed, either out the box or in compatibility mode - fix that
        if (checkIE()) {
            settings.position = 'top';
            settings.css = 'absolute';
        }

        // Any cookie setting scripts to disclose
        var scriptsDisclosure = '';
        if (settings.cookieScripts) {
            var scripts = settings.cookieScripts.split(',');
            var scriptsCount = scripts.length;
            var scriptDisclosureTxt = '';
            if (scriptsCount > 1) {
                for (var t = 0; t < scriptsCount - 1; t++) {
                    scriptDisclosureTxt += scripts[t] + ', ';
                }
                scriptsDisclosure = ' Usamos ' + scriptDisclosureTxt.substring(0, scriptDisclosureTxt.length - 2) + ' y ' + scripts[scriptsCount - 1] + ' scripts, que todas las cookies. ';
            } else {
                scriptsDisclosure = ' We use a ' + scripts[0] + ' script which sets cookies.';
            }
        }

        // Create overlay, vary the disclosure based on explicit/implied consent
        // Set our disclosure/message if one not supplied
        var html = '';
        html += '<div id="epd">';
        html += '<div id="cookiesdirective" style="position:' + settings.css + ';' + settings.position + ':-300px;left:0px;width:100%;'
        html += 'height:auto;background:' + settings.backgroundColor + ';opacity:.' + settings.backgroundOpacity + ';';
        html += '-ms-filter: “alpha(opacity=' + settings.backgroundOpacity + ')”; filter: alpha(opacity=' + settings.backgroundOpacity + ');';
        html += '-khtml-opacity: .' + settings.backgroundOpacity + '; -moz-opacity: .' + settings.backgroundOpacity + ';';
        html += 'color:' + settings.fontColor + ';font-family:' + settings.fontFamily + ';font-size:' + settings.fontSize + ';';
        html += 'text-align:left;z-index:1000;">';
        html += '<div style="font-size: 15px !important; position:relative;height:auto;width:90%;padding:10px;margin-left:auto;margin-right:auto;">';

        if (!settings.message) {
            if (settings.explicitConsent) {
                // Explicit consent message
                settings.message = 'Este sitio utiliza cookies. Algunas de las cookies que';
                settings.message += ' usamos son esenciales para correcto funcionamiento de la web y que ya se han establecido';
            } else {
                // Implied consent message
                //settings.message = 'Hemos colocado las cookies en su ordenador para ayudar a hacer de este sitio web mejor.';
                //settings.message = 'Este sitio web utiliza cookies propias y de terceros para poderte ofrecer una mejor experiencia de navegaci&oacute;n y una atenci&oacute;n personalizada gracias a la informaci&oacute;n estad&iacute;stica que obtenemos tras analizar h&aacute;bitos de navegaci&oacute;n. ';
                settings.message = 'Utilizamos las cookies de Google Analytics para realizar medición y análisis estadístico de la navegación de nuestros visitantes y mejorar así nuestra oferta de productos y servicios. Al navegar por nuestra web, entendemos que aceptas su instalación. <a style="font-size: 15px !important; color: #016ba9;" href="/es/politica_cookies">Más información</a>';


            }
        }

        //html += empresa+"<br>";
        html += settings.message;

        // Build the rest of the disclosure for implied and explicit consent
        if (settings.explicitConsent) {
            // Explicit consent disclosure
            html += scriptsDisclosure + ' Puede eliminar y bloquear todas las cookies de este sitio, pero partes de la web no funcionar&aacute;n.';
            html += 'font-family:' + settings.fontFamily + ';font-size:' + settings.fontSize + ';" href="' + settings.privacyPolicyUri + '" target="_blank"  rel="noopener">pol&iacute;tica de privacidad</a>.<br/>';
            html += '<div id="epdnotick" style="color:#ca0000;display:none;margin:2px;"><span style="background:#cecece;padding:2px;">Usted debe marcar la casilla "Acepto las cookies de este sitio" casilla para aceptar</span></div>'
            html += '<div style="margin-top:5px;">Acepto las cookies de este sitio <input type="checkbox" name="epdagree" id="epdagree" />&nbsp;';
            html += '<input type="submit" style="background-color: #F0F0F0; height: 30px !important;  border: medium none;border-radius: 5px; color: #000 !important; padding: height: 40px !important; 6px;cursor:pointer" name="explicitsubmit" id="explicitsubmit" value="Continue"/><br/></div></div>';

        } else {
            // Implied consent disclosure
            html += '<div style="margin-top:5px;text-align:center;"><input style="background-color: #F0F0F0; height: 30px !important; border: medium none;border-radius: 5px; font-size: 18px; font-weight: bold; color:#fff!important; background: #016ba9;height: 40px !important; padding: 6px;cursor:pointer" type="submit" name="impliedsubmit" id="impliedsubmit" value="Acepto"/></div></div>';
        }

        html += '</div></div>';
        $('body').append(html);
        // 03 / 03 / 2014
        // Serve the disclosure, and be smarter about branching
        var dp = settings.position.toLowerCase();
        if (dp != 'top' && dp != 'bottom') {
            dp = 'top';
        }
        var opts = new Array();
        if (dp == 'top') {
            opts['in'] = { 'top': '0' };
            opts['out'] = { 'top': '-300' };
        } else {
            opts['in'] = { 'bottom': '0' };
            opts['out'] = { 'bottom': '-300' };
        }

        // Start animation
        $('#cookiesdirective').animate(opts['in'], 1000, function() {
            // Set event handlers depending on type of disclosure
            if (settings.explicitConsent) {
                // Explicit, need to check a box and click a button
                $('#explicitsubmit').click(function() {
                    if ($('#epdagree').is(':checked')) {
                        // Set a cookie to prevent this being displayed again
                        setCookie('cookiesDirective', 1, 365);
                        // Close the overlay
                        $('#cookiesdirective').animate(opts['out'], 1000, function() {
                            // Remove the elements from the DOM and reload page
                            $('#cookiesdirective').remove();
                            location.reload(true);
                        });
                    } else {
                        // We need the box checked we want "explicit consent", display message
                        $('#epdnotick').css('display', 'block');
                    }
                });
            } else {
                // Implied consent, just a button to close it
                $('#impliedsubmit').click(function() {
                    // Set a cookie to prevent this being displayed again
                    setCookie('cookiesDirective', 1, 365);
                    // Close the overlay
                    $('#cookiesdirective').animate(opts['out'], 1000, function() {
                        // Remove the elements from the DOM and reload page
                        $('#cookiesdirective').remove();
                    });
                });
            }

            // Set a timer to remove the warning after 'settings.duration' seconds
            setTimeout(function() {
                $('#cookiesdirective').animate({
                    opacity: '0'
                }, 2000, function() {
                    $('#cookiesdirective').css(dp, '-300px');
                });
            }, settings.duration * 1000);
        });
    }
})(jQuery);


// WEBPACK FOOTER //
// ./assets/js/vendors/jquery.cookiesdirective_es.js